import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { useUserStore } from '@/stores/user'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        name: 'home',
        redirect: '/create',
      },
      {
        path: 'create',
        name: 'create',
        component: () => import('@/pages/CreatePage.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'acrylic',
        name: 'acrylic',
        component: () => import('@/pages/AcrylicPage.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'line-art',
        name: 'line-art',
        component: () => import('@/pages/LineArtPage.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'coloring-feedback-test',
        name: 'coloring-feedback-test',
        component: () => import('@/pages/ColoringTestPage.vue'),
        props: { penType: 'marker' },
        meta: { requiresAuth: true },
      },
      {
        path: 'coloring-test',
        name: 'coloring-test',
        component: () => import('@/pages/ColoringTestPage.vue'),
        props: { penType: 'marker' },
        meta: { requiresAuth: true },
      },
      {
        path: 'acrylic-test',
        name: 'acrylic-test',
        component: () => import('@/pages/ColoringTestPage.vue'),
        props: { penType: 'acrylic' },
        meta: { requiresAuth: true },
      },
      {
        path: 'feedback',
        name: 'feedback',
        component: () => import('@/pages/FeedbackPage.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'coloring-feedback',
        name: 'coloring-feedback',
        component: () => import('@/pages/ColoringFeedbackPage.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'prompt-overrides',
        name: 'prompt-overrides',
        component: () => import('@/pages/PromptOverridePage.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'my-works',
        name: 'my-works',
        component: () => import('@/pages/MyWorksPage.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'gallery',
        name: 'gallery',
        component: () => import('@/pages/GalleryPage.vue'),
      },
      {
        path: 'artwork/:id',
        name: 'artwork-detail',
        component: () => import('@/pages/ArtworkDetailPage.vue'),
      },
      {
        path: 'palettes',
        name: 'palettes',
        component: () => import('@/pages/PalettesPage.vue'),
        meta: { requiresAuth: true },
      },
      // Debug Playground
      {
        path: 'debug',
        name: 'debug',
        component: () => import('@/pages/DebugPlaygroundPage.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'debug/history',
        name: 'debug-history',
        component: () => import('@/pages/DebugHistoryPage.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'debug/session/:id',
        name: 'debug-session',
        component: () => import('@/pages/DebugPlaygroundPage.vue'),
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/LoginPage.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/pages/RegisterPage.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/pages/NotFoundPage.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// 路由守卫
router.beforeEach((to, _from, next) => {
  const userStore = useUserStore()

  if (to.meta.requiresAuth && !userStore.isLoggedIn) {
    next({ name: 'login', query: { redirect: to.fullPath } })
  } else {
    next()
  }
})

export default router
